// 桌面與手機／平板共用的 Logo 清單；更新圖檔、排序或尺寸時只需修改此處。
export const strategicPartnerGroups = [
  {
    desktopGap: '20px',
    logos: [
      {
        src: '/images/logos/A1.webp?patch=1.22',
        alt: 'Logo A1',
        height: 80,
      },
      {
        src: '/images/logos/A2.webp?patch=1.22',
        alt: 'Logo A2',
        height: 55,
      },
      {
        src: '/images/logos/A3.webp?patch=1.22',
        alt: 'Logo A3',
        height: 55,
      },
      {
        src: '/images/logos/A4.webp?patch=1.22',
        alt: 'Logo A4',
        height: 50,
      },
      {
        src: '/images/logos/A5.webp?patch=1.22',
        alt: 'Logo A5',
        height: 65,
      },
      {
        src: '/images/logos/A6.webp?patch=1.22',
        alt: 'Logo A6',
        height: 50,
      },
      {
        src: '/images/logos/A7.webp?patch=1.22',
        alt: 'Logo A7',
        height: 50,
      },
      {
        src: '/images/logos/A8.webp?patch=1.22',
        alt: 'Logo A8',
        height: 50,
      },
    ],
  },
  {
    desktopGap: '5px',
    logos: [
      {
        src: '/images/logos/B1.webp?patch=1.22',
        alt: 'Logo B1',
        height: 50,
      },
      {
        src: '/images/logos/B2.webp?patch=1.22',
        alt: 'Logo B2',
        height: 50,
      },
      {
        src: '/images/logos/B3.webp?patch=1.22',
        alt: 'Logo B3',
        height: 60,
      },
      {
        src: '/images/logos/B4.webp?patch=1.22',
        alt: 'Logo B4',
        height: 55,
      },
      {
        src: '/images/logos/B5.webp?patch=1.22',
        alt: 'Logo B5',
        height: 70,
      },
      {
        src: '/images/logos/B6.webp?patch=1.22',
        alt: 'Logo B6',
        height: 50,
      },
      {
        src: '/images/logos/B7.webp?patch=1.22',
        alt: 'Logo B7',
        height: 50,
      },
      {
        src: '/images/logos/B8.webp?patch=1.22',
        alt: 'Logo B8',
        height: 50,
      },
    ],
  },
  {
    desktopGap: '40px',
    logos: [
      {
        src: '/images/logos/C1.webp?patch=1.22',
        alt: 'Logo C1',
        height: 90,
      },
      {
        src: '/images/logos/C2.webp?patch=1.22',
        alt: 'Logo C2',
        height: 50,
      },
      {
        src: '/images/logos/C3.webp?patch=1.22',
        alt: 'Logo C3',
        height: 50,
      },
      {
        src: '/images/logos/C4.webp?patch=1.22',
        alt: 'Logo C4',
        height: 65,
      },
      {
        src: '/images/logos/C5.webp?patch=1.22',
        alt: 'Logo C5',
        height: 65,
      },
      {
        src: '/images/logos/C6.webp?patch=1.22',
        alt: 'Logo C6',
        height: 70,
      },
    ],
  },
  {
    desktopGap: '30px',
    logos: [
      {
        src: '/images/logos/D1.webp?patch=1.22',
        alt: 'Logo D1',
        height: 65,
      },
      {
        src: '/images/logos/D2.webp?patch=1.22',
        alt: 'Logo D2',
        height: 60,
      },
      {
        src: '/images/logos/D3.webp?patch=1.22',
        alt: 'Logo D3',
        height: 80,
      },
      {
        src: '/images/logos/D4.webp?patch=1.22',
        alt: 'Logo D4',
        height: 110,
      },
      {
        src: '/images/logos/D5.webp?patch=1.22',
        alt: 'Logo D5',
        height: 55,
      },
      {
        src: '/images/logos/D6.webp?patch=1.22',
        alt: 'Logo D6',
        height: 85,
      },
      {
        src: '/images/logos/D7.webp?patch=1.22',
        alt: 'Logo D7',
        height: 50,
      },
    ],
  },
  {
    desktopGap: '40px',
    logos: [
      {
        src: '/images/logos/E1.webp?patch=1.22',
        alt: 'Logo E1',
        height: 60,
      },
      {
        src: '/images/logos/E2.webp?patch=1.22',
        alt: 'Logo E2',
        height: 70,
      },
      {
        src: '/images/logos/E3.webp?patch=1.22',
        alt: 'Logo E3',
        height: 80,
      },
      {
        src: '/images/logos/E4.webp?patch=1.22',
        alt: 'Logo E4',
        height: 60,
      },
      {
        src: '/images/logos/E5.webp?patch=1.22',
        alt: 'Logo E5',
        height: 60,
      },
      {
        src: '/images/logos/E6.webp?patch=1.22',
        alt: 'Logo E6',
        height: 75,
      },
      {
        src: '/images/logos/E7.webp?patch=1.22',
        alt: 'Logo E7',
        height: 100,
      },
      {
        src: '/images/logos/E8.webp?patch=1.22',
        alt: 'Logo E8',
        height: 120,
      },
    ],
  },
  {
    desktopGap: '40px',
    logos: [
      {
        src: '/images/logos/F1.webp?patch=1.22',
        alt: 'Logo F1',
        height: 80,
      },
      {
        src: '/images/logos/F2.webp?patch=1.22',
        alt: 'Logo F2',
        height: 80,
      },
      {
        src: '/images/logos/F3.webp?patch=1.22',
        alt: 'Logo F3',
        height: 50,
      },
      {
        src: '/images/logos/F4.webp?patch=1.22',
        alt: 'Logo F4',
        height: 50,
      },
      {
        src: '/images/logos/F5.webp?patch=1.22',
        alt: 'Logo F5',
        height: 30,
      },
      {
        src: '/images/logos/F6.webp?patch=1.22',
        alt: 'Logo F6',
        height: 50,
      },
      {
        src: '/images/logos/F7.webp?patch=1.22',
        alt: 'Logo F7',
        height: 40,
      },
      {
        src: '/images/logos/F8.webp?patch=1.22',
        alt: 'Logo F8',
        height: 45,
      },
    ],
  },
];

export const supportingOrganisationLogos = [
  { src: '/images/logos/G1.webp', alt: 'Logo G1', height: 50 },
  { src: '/images/logos/G2.webp', alt: 'Logo G2', height: 50 },
  { src: '/images/logos/G3.webp', alt: 'Logo G3', height: 65 },
];
